// if (!customElements.get('media-gallery')) {
//   customElements.define(
//     'media-gallery',
//     class MediaGallery extends HTMLElement {
//       constructor() {
//         super();

//         this.selectors = {
//           viewer: '[id^="GalleryViewer"]',
//           thumbnails: '[id^="GalleryThumbnails"]',
//           mediaList: '[id^="Slider-Gallery"]',
//           mediaItems: ['.product__media-item'],
//         };

//         this.sliderInstance = false;
//         this.thumbsInstance = false;
//       }

//       connectedCallback() {
//         this.init();
//       }

//       init() {
//         this.elements = window.FoxTheme.utils.queryDomNodes(this.selectors, this);
//         this.mediaLayout = this.dataset.mediaLayout;
//         this.onlyImage = this.dataset.onlyImage === 'true';
//         this.enableDesktopSlider = this.dataset.enableDesktopSlider === 'true';
//         this.enableMobileThumbnails = this.dataset.enableMobileThumbnails === 'true';
//         this.enableImageZoom = this.dataset.enableImageZoom === 'true';
//         this.setSliderOptions();

//         const mql = window.matchMedia(FoxTheme.config.mediaQueryMobile);
//         mql.onchange = this.updateMediaLayout.bind(this);
//         this.updateMediaLayout();

//         if (this.enableImageZoom) {
//           this.initImageZoom();
//         }
//       }

//       setSliderOptions() {
//         const mediaItemGap = parseInt(this.dataset.mediaItemGap);

//         this.sliderOptions = {
//           init: false,
//           slidesPerView: '1',
//           spaceBetween: mediaItemGap,
//           loop: true,
//           grabCursor: true,
//           allowTouchMove: true,
//           autoHeight: true,
//           navigation: {
//             nextEl: this.querySelector('.swiper-button-next'),
//             prevEl: this.querySelector('.swiper-button-prev'),
//           },
//           pagination: {
//             el: this.querySelector('.swiper-pagination'),
//             clickable: true,
//             type: 'fraction',
//           },
//           threshold: 2,
//         };

//         this.thumbsOptions = {
//           slidesPerView: 4,
//           breakpoints: {
//             461: {
//               slidesPerView: 5,
//             },
//           },
//           spaceBetween: mediaItemGap,
//           loop: false,
//           freeMode: true,
//           watchSlidesProgress: true,
//           threshold: 2,
//         };

//         switch (this.mediaLayout) {
//           case 'vertical-carousel':
//             this.thumbsOptions = Object.assign({}, this.thumbsOptions, {
//               breakpoints: {
//                 768: {
//                   direction: 'vertical',
//                   slidesPerView: 'auto',
//                 },
//               },
//             });
//             break;
//           case 'slider-freemode':
//             this.sliderOptions = Object.assign({}, this.sliderOptions, {
//               slidesPerView: 'auto',
//             });
//             break;
//         }
//       }

//       updateMediaLayout() {
//         if (FoxTheme.config.mqlMobile) {
//           this.initSlider();
//         } else {
//           if (this.enableDesktopSlider) {
//             this.initSlider();
//           } else {
//             this.destroySlider();
//           }
//         }
//       }

//       initSlider() {
//         if (typeof this.sliderInstance !== 'object') {
//           if ((this.enableDesktopSlider || this.enableMobileThumbnails) && this.elements.thumbnails) {
//             this.thumbsInstance = new window.FoxTheme.Carousel(this.elements.thumbnails, this.thumbsOptions);
//             this.thumbsInstance.init();

//             this.sliderOptions.thumbs = {
//               swiper: this.thumbsInstance.slider,
//               autoScrollOffset: 2,
//             };
//           }

//           this.sliderInstance = new window.FoxTheme.Carousel(this.elements.viewer, this.sliderOptions, [
//             FoxTheme.Swiper.Thumbs,
//           ]);
//           this.sliderInstance.init();

//           this.handleSliderAfterInit();
//           this.handleSlideChange();

//           this.sliderInstance.slider.init();
//         }
//       }

//       destroySlider() {
//         if (typeof this.sliderInstance === 'object') {
//           this.sliderInstance.slider.destroy();
//           this.sliderInstance = false;
//         }
//       }

//       initThumbsSlider() {
//         if (typeof this.thumbsInstance !== 'object') {
//           this.thumbsInstance = new window.FoxTheme.Carousel(this.selectors.thumbnails, this.thumbsOptions);
//           this.thumbsInstance.init();
//         }
//       }

//       initImageZoom() {
//         let dataSource = [];
//         const allMedia = [...this.querySelectorAll('.product__media-item:not(.swiper-slide-duplicate)')];
//         if (allMedia) {
//           allMedia.forEach((media) => {
//             switch (media.dataset.mediaType) {
//               case 'model':
//                 dataSource.push({
//                   id: media.dataset.mediaIndex,
//                   html: `<div class="pswp__item--${media.dataset.mediaType}">${
//                     media.querySelector('product-model').outerHTML
//                   }</div>`,
//                   mediaType: media.dataset.mediaType,
//                 });
//                 break;
//               case 'video':
//               case 'external_video':
//                 dataSource.push({
//                   id: media.dataset.mediaIndex,
//                   html: `<div class="pswp__item--${media.dataset.mediaType}">${
//                     media.querySelector('video-element').outerHTML
//                   }</div>`,
//                   mediaType: media.dataset.mediaType,
//                 });
//                 break;
//               case 'image':
//                 dataSource.push({
//                   id: media.dataset.mediaIndex,
//                   src: media.dataset.src,
//                   width: media.dataset.pswpWidth,
//                   height: media.dataset.pswpHeight,
//                   mediaType: media.dataset.mediaType,
//                 });
//                 break;
//             }
//           });
//         }

//         this.lightbox = new window.FoxTheme.PhotoSwipeLightbox({
//           dataSource: dataSource,
//           pswpModule: window.FoxTheme.PhotoSwipe,
//           bgOpacity: 1,
//           arrowPrev: false,
//           arrowNext: false,
//           zoom: false,
//           close: false,
//           counter: false,
//           preloader: false,
//         });

//         this.lightbox.addFilter('thumbEl', (thumbEl, { id }, index) => {
//           if (this.sliderInstance && this.sliderInstance.slider) {
//             const { slides, activeIndex } = this.sliderInstance.slider;
//             if (slides[activeIndex]) {
//               const el = slides[activeIndex].querySelector('img');
//               if (el) {
//                 return el;
//               }
//             }
//           }

//           return thumbEl;
//         });

//         this.lightbox.addFilter('placeholderSrc', (placeholderSrc, { data: { id } }) => {
//           if (this.sliderInstance && this.sliderInstance.slider) {
//             const { slides, activeIndex } = this.sliderInstance.slider;
//             if (slides[activeIndex]) {
//               const el = slides[activeIndex].querySelector('img');
//               if (el) {
//                 return el.src;
//               }
//             }
//           }

//           return placeholderSrc;
//         });

//         this.lightbox.on('change', () => {
//           window.pauseAllMedia(this);
//           if (this.sliderInstance && this.sliderInstance.slider) {
//             const { currIndex } = this.lightbox.pswp;
//             if (this.sliderInstance.slider.realIndex !== currIndex) {
//               this.sliderInstance.slider.slideToLoop(currIndex, 100, false);
//             }
//           }
//         });

//         this.lightbox.on('pointerDown', (e) => {
//           if (this.lightbox.pswp.currSlide.data.mediaType != 'image') {
//             e.preventDefault();
//           }
//         });

//         this.lightbox.on('uiRegister', () => {
//           if (!this.onlyImage) {
//             this.lightbox.pswp.ui.registerElement({
//               name: 'next',
//               ariaLabel: 'Next slide',
//               order: 3,
//               isButton: true,
//               html: '<svg class="pswp-icon-next flip-x" viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 65,90 L 25,50  L 65,10 L 60,0 Z"></path></svg>',
//               onClick: (event, el) => {
//                 this.lightbox.pswp.next();
//               },
//             });
//             this.lightbox.pswp.ui.registerElement({
//               name: 'prev',
//               ariaLabel: 'Previous slide',
//               order: 1,
//               isButton: true,
//               html: '<svg class="pswp-icon-prev rtl-flip-x" viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 65,90 L 25,50  L 65,10 L 60,0 Z"></path></svg>',
//               onClick: (event, el) => {
//                 this.lightbox.pswp.prev();
//               },
//             });
//           }
//           this.lightbox.pswp.ui.registerElement({
//             name: 'close-zoom',
//             ariaLabel: 'Close zoom image',
//             order: 2,
//             isButton: true,
//             html: '<svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" role="presentation" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>',
//             onClick: (event, el) => {
//               this.lightbox.pswp.close();
//             },
//           });
//         });

//         this.lightbox.init();

//         FoxTheme.utils.addEventDelegate({
//           selector: '.js-photoswipe--zoom',
//           context: this,
//           handler: (e, media) => {
//             if (media.dataset.mediaType === 'image') {
//               const index = Number(media.dataset.mediaIndex) || 0;
//               this.lightbox.loadAndOpen(index);
//             }
//           },
//         });
//       }

//       handleSliderAfterInit() {
//         this.sliderInstance.slider.on('afterInit', (swiper) => {
//           const { slides, activeIndex } = swiper;

//           if (slides[activeIndex]) {
//             const isModelMediaType = slides[activeIndex].dataset.mediaType === 'model';
//             this.toggleSliderDraggableState(!isModelMediaType);
//           }
//         });
//       }

//       handleSlideChange() {
//         this.sliderInstance.slider.on('realIndexChange', (swiper) => {
//           const { slides, activeIndex, thumbs } = swiper;

//           if (thumbs.swiper) {
//             thumbs.swiper.slideTo(activeIndex);
//           }

//           if (slides[activeIndex]) {
//             this.playActiveMedia(slides[activeIndex]);

//             const isModelMediaType = slides[activeIndex].dataset.mediaType === 'model';
//             this.toggleSliderDraggableState(!isModelMediaType);
//           }
//         });
//       }

//       toggleSliderDraggableState(isDraggable) {
//         if (this.sliderInstance.slider.allowTouchMove !== isDraggable) {
//           this.sliderInstance.slider.allowTouchMove = isDraggable;
//         }
//       }

//       playActiveMedia(selected) {
//         const deferredMedia = selected.querySelector('product-model');
//         if (deferredMedia) deferredMedia.loadContent(false);
//       }

//       setActiveMedia(variant) {
//         if (!variant || !variant.hasOwnProperty('featured_media') || !variant.featured_media) return;

//         if (this.sliderInstance.slider) {
//           const slideIndex = variant.featured_media.position || 0;
//           this.sliderInstance.slider.slideToLoop(slideIndex - 1);
//         } else {
//           this.sortMediaItems(variant);
//         }
//       }

//       sortMediaItems(variant) {
//         let newMedias = this.elements.mediaItems;

//         // Reset ordering.
//         newMedias.sort(function (a, b) {
//           return a.dataset.mediaIndex - b.dataset.mediaIndex;
//         });

//         newMedias.some((media, index) => {
//           if (media.dataset.mediaId == variant.featured_media.id) {
//             const [element] = newMedias.splice(index, 1);
//             newMedias.unshift(element);
//             return true;
//           }
//         });

//         this.elements.mediaList.innerHTML = '';
//         newMedias.forEach((media) => {
//           this.elements.mediaList.appendChild(media);
//         });

//         if (!FoxTheme.config.mqlMobile) {
//           const selectedMedia = this.querySelector(`[data-media-id="${variant.featured_media.id}"]`);
//           if (selectedMedia) {
//             window.scrollTo({ top: selectedMedia.offsetTop, behavior: 'smooth' });
//           }
//         }
//       }
//     }
//   );
// }



// Image slide fix 


console.log('MEDIA GALLERY CLEAN FINAL LOADED');
 
if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
 
        this.selectors = {
          viewer: '[id^="GalleryViewer"]',
          thumbnails: '[id^="GalleryThumbnails"]',
          mediaList: '[id^="Slider-Gallery"]',
          mediaItems: ['.product__media-item'],
        };
 
        this.sliderInstance = false;
        this.thumbsInstance = false;
        this.lightbox = false;
      }
 
      connectedCallback() {
        // Skip initialization if this element is hidden (display:none).
        // There may be multiple media-gallery elements on the page;
        // only the visible one should initialize.
        if (getComputedStyle(this).display === 'none') return;
        this.init();
      }
 
      init() {
        this.elements = window.FoxTheme.utils.queryDomNodes(this.selectors, this);
        this.mediaLayout = this.dataset.mediaLayout === 'slider-freemode' ? 'carousel' : this.dataset.mediaLayout;
        this.dataset.mediaLayout = this.mediaLayout;
 
        this.onlyImage = this.dataset.onlyImage === 'true';
        this.enableDesktopSlider = this.dataset.enableDesktopSlider === 'true';
        this.enableMobileThumbnails = this.dataset.enableMobileThumbnails === 'true';
        this.enableImageZoom = this.dataset.enableImageZoom === 'true';
 
        this.setSliderOptions();
 
        const mql = window.matchMedia(FoxTheme.config.mediaQueryMobile);
        mql.onchange = this.updateMediaLayout.bind(this);
        this.updateMediaLayout();
 
        if (this.enableImageZoom) {
          this.initImageZoom();
        }
 
        this.bindDimensionImageZoom();
      }
 
      setSliderOptions() {
        const mediaItemGap = parseInt(this.dataset.mediaItemGap) || 0;
 
        this.sliderOptions = {
          init: false,
          slidesPerView: 1,
          slidesPerGroup: 1,
          centeredSlides: false,
          spaceBetween: 0,
          loop: false,
          rewind: true,
          grabCursor: true,
          allowTouchMove: true,
          autoHeight: true,
          observer: true,
          observeParents: true,
          resizeObserver: true,
          watchOverflow: true,
          roundLengths: true,
          preventInteractionOnTransition: true,
 
          navigation: {
            nextEl: this.querySelector('.swiper-button-next'),
            prevEl: this.querySelector('.swiper-button-prev'),
          },
 
          pagination: {
            el: this.querySelector('.swiper-pagination'),
            clickable: true,
            type: 'fraction',
          },
 
          threshold: 2,
          breakpoints: {},
        };
 
        this.thumbsOptions = {
          slidesPerView: 4,
          breakpoints: {
            461: {
              slidesPerView: 5,
            },
          },
          spaceBetween: mediaItemGap,
          loop: false,
          freeMode: true,
          watchSlidesProgress: true,
          threshold: 2,
        };
 
        switch (this.mediaLayout) {
          case 'vertical-carousel':
            this.thumbsOptions = Object.assign({}, this.thumbsOptions, {
              breakpoints: {
                768: {
                  direction: 'vertical',
                  slidesPerView: 'auto',
                },
              },
            });
            break;
 
          case 'slider-freemode':
          case 'carousel':
          default:
            this.sliderOptions = Object.assign({}, this.sliderOptions, {
              slidesPerView: 1,
              slidesPerGroup: 1,
              centeredSlides: false,
              loop: false,
              rewind: true,
              breakpoints: {},
            });
            break;
        }
      }
 
      updateMediaLayout() {
        if (FoxTheme.config.mqlMobile) {
          this.initSlider();
        } else {
          if (this.enableDesktopSlider) {
            this.initSlider();
          } else {
            this.destroySlider();
          }
        }
      }
 
      initSlider() {
        if (typeof this.sliderInstance !== 'object') {
          if ((this.enableDesktopSlider || this.enableMobileThumbnails) && this.elements.thumbnails) {
            this.thumbsInstance = new window.FoxTheme.Carousel(this.elements.thumbnails, this.thumbsOptions);
            this.thumbsInstance.init();
 
            this.sliderOptions.thumbs = {
              swiper: this.thumbsInstance.slider,
              autoScrollOffset: 2,
            };
          }
 
          this.sliderInstance = new window.FoxTheme.Carousel(this.elements.viewer, this.sliderOptions, [
            FoxTheme.Swiper.Thumbs,
          ]);
 
          this.sliderInstance.init();
 
          this.handleSliderAfterInit();
          this.handleSlideChange();
 
          this.sliderInstance.slider.init();
 
          setTimeout(() => {
            this.updateSliderLayout();
          }, 100);
 
          setTimeout(() => {
            this.updateSliderLayout();
          }, 500);
 
          setTimeout(() => {
            this.updateSliderLayout();
          }, 1000);
        }
      }
 
      forceSingleSlideLayout() {
        const viewer = this.elements?.viewer || this.querySelector('[id^="GalleryViewer"]');
        const wrapper = this.querySelector('[id^="Slider-Gallery"]');
        const slides = this.getCleanMediaItems();
 
        if (!viewer || !wrapper || !slides.length) return;
 
        this.dataset.mediaLayout = 'carousel';
 
        viewer.style.overflow = 'hidden';
        viewer.style.width = '100%';
        viewer.style.maxWidth = '100%';
 
        wrapper.style.display = 'flex';
        wrapper.style.flexWrap = 'nowrap';
        wrapper.style.alignItems = 'flex-start';
        // Do NOT set wrapper.style.width — Swiper must own the wrapper width
        // so its translateX(-N * slideWidth) math stays correct.
 
        const viewerWidth = Math.round(viewer.getBoundingClientRect().width || viewer.clientWidth || 0);
 
        slides.forEach((slide) => {
          if (viewerWidth > 0) {
            // Pixel width so Swiper's stored slidesSizesGrid matches exactly
            slide.style.width = viewerWidth + 'px';
            slide.style.minWidth = viewerWidth + 'px';
            slide.style.maxWidth = viewerWidth + 'px';
            slide.style.flex = '0 0 ' + viewerWidth + 'px';
          } else {
            slide.style.width = '100%';
            slide.style.minWidth = '100%';
            slide.style.maxWidth = '100%';
            slide.style.flex = '0 0 100%';
          }
          slide.style.flexShrink = '0';
        });
 
        if (this.sliderInstance && this.sliderInstance.slider) {
          const swiper = this.sliderInstance.slider;
 
          swiper.params.slidesPerView = 1;
          swiper.params.slidesPerGroup = 1;
          swiper.params.centeredSlides = false;
          swiper.params.loop = false;
          swiper.params.rewind = true;
          swiper.params.breakpoints = {};
 
          if (swiper.originalParams) {
            swiper.originalParams.slidesPerView = 1;
            swiper.originalParams.slidesPerGroup = 1;
            swiper.originalParams.centeredSlides = false;
            swiper.originalParams.loop = false;
            swiper.originalParams.rewind = true;
            swiper.originalParams.breakpoints = {};
          }
        }
      }
 
      updateSliderLayout() {
        this.forceSingleSlideLayout();
 
        if (this.sliderInstance && this.sliderInstance.slider) {
          const swiper = this.sliderInstance.slider;
          const index = typeof swiper.realIndex === 'number' ? swiper.realIndex : 0;
 
          swiper.update();
          swiper.slideTo(index, 0, false);
        }
 
        if (this.thumbsInstance && this.thumbsInstance.slider) {
          this.thumbsInstance.slider.update();
        }
 
        setTimeout(() => {
          this.forceSingleSlideLayout();
 
          if (this.sliderInstance && this.sliderInstance.slider) {
            const swiper = this.sliderInstance.slider;
            const index = typeof swiper.realIndex === 'number' ? swiper.realIndex : 0;
 
            swiper.update();
            swiper.slideTo(index, 0, false);
          }
        }, 100);
      }
 
      destroySlider() {
        if (typeof this.sliderInstance === 'object') {
          this.sliderInstance.slider.destroy(true, true);
          this.sliderInstance = false;
        }
 
        if (typeof this.thumbsInstance === 'object') {
          this.thumbsInstance.slider.destroy(true, true);
          this.thumbsInstance = false;
        }
      }
 
      initThumbsSlider() {
        if (typeof this.thumbsInstance !== 'object' && this.elements.thumbnails) {
          this.thumbsInstance = new window.FoxTheme.Carousel(this.elements.thumbnails, this.thumbsOptions);
          this.thumbsInstance.init();
        }
      }
 
      getCleanMediaItems() {
        return [...this.querySelectorAll('[id^="GalleryViewer"] .product__media-item:not(.swiper-slide-duplicate)')];
      }
 
      getMediaIndex(media) {
        const allMedia = this.getCleanMediaItems();
 
        const index = allMedia.findIndex((item) => {
          return item === media || item.dataset.mediaId === media.dataset.mediaId;
        });
 
        return index >= 0 ? index : 0;
      }
 
      jumpToMediaIndex(index) {
        if (!this.sliderInstance || !this.sliderInstance.slider) return;
 
        this.forceSingleSlideLayout();
 
        const mediaItems = this.getCleanMediaItems();
        const maxIndex = mediaItems.length - 1;
 
        let safeIndex = Number(index) || 0;
 
        if (safeIndex < 0) safeIndex = 0;
        if (safeIndex > maxIndex) safeIndex = maxIndex;
 
        const swiper = this.sliderInstance.slider;
 
        swiper.update();
        swiper.slideTo(safeIndex, 0, false);
 
        if (this.thumbsInstance && this.thumbsInstance.slider) {
          this.thumbsInstance.slider.slideTo(safeIndex, 0, false);
          this.thumbsInstance.slider.update();
        }
 
        setTimeout(() => {
          this.forceSingleSlideLayout();
          swiper.update();
          swiper.slideTo(safeIndex, 0, false);
        }, 100);
      }
 
      buildProductDataSource() {
        const dataSource = [];
        const allMedia = this.getCleanMediaItems();
 
        allMedia.forEach((media, index) => {
          switch (media.dataset.mediaType) {
            case 'model':
              if (media.querySelector('product-model')) {
                dataSource.push({
                  id: media.dataset.mediaIndex || String(index),
                  html: `<div class="pswp__item--${media.dataset.mediaType}">${
                    media.querySelector('product-model').outerHTML
                  }</div>`,
                  mediaType: media.dataset.mediaType,
                });
              }
              break;
 
            case 'video':
            case 'external_video':
              if (media.querySelector('video-element')) {
                dataSource.push({
                  id: media.dataset.mediaIndex || String(index),
                  html: `<div class="pswp__item--${media.dataset.mediaType}">${
                    media.querySelector('video-element').outerHTML
                  }</div>`,
                  mediaType: media.dataset.mediaType,
                });
              }
              break;
 
            case 'image': {
              const image = media.querySelector('img');
 
              dataSource.push({
                id: media.dataset.mediaIndex || String(index),
                src: media.dataset.pswpSrc || media.dataset.src || image?.currentSrc || image?.src,
                width: Number(media.dataset.pswpWidth) || Number(image?.naturalWidth) || 2000,
                height: Number(media.dataset.pswpHeight) || Number(image?.naturalHeight) || 2000,
                mediaType: media.dataset.mediaType,
              });
              break;
            }
          }
        });
 
        return dataSource;
      }
 
      createLightbox(dataSource) {
        const lightbox = new window.FoxTheme.PhotoSwipeLightbox({
          dataSource: dataSource,
          pswpModule: window.FoxTheme.PhotoSwipe,
          bgOpacity: 1,
          arrowPrev: false,
          arrowNext: false,
          close: false,
          counter: false,
          preloader: false,
          wheelToZoom: true,
          imageClickAction: 'zoom',
          tapAction: 'zoom',
          doubleTapAction: 'zoom',
          initialZoomLevel: 'fit',
          secondaryZoomLevel: 2.5,
          maxZoomLevel: 4,
        });
 
        lightbox.on('uiRegister', () => {
          if (!lightbox.pswp) return;
 
          lightbox.pswp.ui.registerElement({
            name: 'next',
            ariaLabel: 'Next slide',
            order: 3,
            isButton: true,
            html: '<svg class="pswp-icon-next flip-x" viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 65,90 L 25,50 L 65,10 L 60,0 Z"></path></svg>',
            onClick: () => {
              lightbox.pswp.next();
            },
          });
 
          lightbox.pswp.ui.registerElement({
            name: 'prev',
            ariaLabel: 'Previous slide',
            order: 1,
            isButton: true,
            html: '<svg class="pswp-icon-prev rtl-flip-x" viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 65,90 L 25,50 L 65,10 L 60,0 Z"></path></svg>',
            onClick: () => {
              lightbox.pswp.prev();
            },
          });
 
          lightbox.pswp.ui.registerElement({
            name: 'close-zoom',
            ariaLabel: 'Close zoom image',
            order: 2,
            isButton: true,
            html: '<svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" role="presentation" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>',
            onClick: () => {
              lightbox.pswp.close();
            },
          });
        });
 
        lightbox.init();
 
        return lightbox;
      }
 
      initImageZoom() {
        const dataSource = this.buildProductDataSource();
 
        this.lightbox = this.createLightbox(dataSource);
 
        this.lightbox.addFilter('thumbEl', (thumbEl) => {
          if (this.sliderInstance && this.sliderInstance.slider) {
            const { slides, activeIndex } = this.sliderInstance.slider;
 
            if (slides[activeIndex]) {
              const el = slides[activeIndex].querySelector('img');
              if (el) return el;
            }
          }
 
          return thumbEl;
        });
 
        this.lightbox.addFilter('placeholderSrc', (placeholderSrc) => {
          if (this.sliderInstance && this.sliderInstance.slider) {
            const { slides, activeIndex } = this.sliderInstance.slider;
 
            if (slides[activeIndex]) {
              const el = slides[activeIndex].querySelector('img');
              if (el) return el.currentSrc || el.src;
            }
          }
 
          return placeholderSrc;
        });
 
        this.lightbox.on('change', () => {
          window.pauseAllMedia(this);
 
          if (this.sliderInstance && this.sliderInstance.slider && this.lightbox.pswp) {
            const currIndex = this.lightbox.pswp.currIndex || 0;
 
            if (this.sliderInstance.slider.realIndex !== currIndex) {
              this.jumpToMediaIndex(currIndex);
            }
          }
        });
 
        // After PhotoSwipe closes, re-fix the gallery layout.
        // We must wait until the gallery element is visible again (display≠none)
        // before measuring widths, then force slide widths to pixel values.
        const fixAfterClose = () => {
          this.style.display = '';
 
          const viewer = this.querySelector('[id^="GalleryViewer"]');
          const wrapper = this.querySelector('[id^="Slider-Gallery"]');
          const swiper = this.sliderInstance && this.sliderInstance.slider;
 
          if (!viewer || !wrapper || !swiper) return;
 
          // Use offsetWidth (works even when parent is visible but element was hidden)
          const w = viewer.offsetWidth || viewer.clientWidth || swiper.width || 0;
          if (!w) return;
 
          const slides = Array.from(
            this.querySelectorAll('[id^="GalleryViewer"] .product__media-item:not(.swiper-slide-duplicate)')
          );
 
          wrapper.style.width = (w * slides.length) + 'px';
          slides.forEach((slide) => {
            slide.style.width = w + 'px';
            slide.style.minWidth = w + 'px';
            slide.style.maxWidth = w + 'px';
            slide.style.flex = '0 0 ' + w + 'px';
            slide.style.flexShrink = '0';
          });
 
          swiper.update();
          swiper.slideTo(swiper.activeIndex, 0, false);
        };
 
        this.lightbox.on('closingAnimationEnd', () => {
          requestAnimationFrame(fixAfterClose);
          setTimeout(fixAfterClose, 100);
          setTimeout(fixAfterClose, 300);
        });
 
        this.lightbox.on('destroy', () => {
          requestAnimationFrame(fixAfterClose);
          setTimeout(fixAfterClose, 100);
          setTimeout(fixAfterClose, 300);
        });
 
        this.lightbox.on('pointerDown', (e) => {
          if (this.lightbox.pswp.currSlide.data.mediaType !== 'image') {
            e.preventDefault();
          }
        });
 
        this.addEventListener(
          'click',
          (e) => {
            const trigger = e.target.closest('.js-photoswipe--zoom');
 
            if (!trigger) return;
 
            const media = trigger.closest('.product__media-item');
 
            if (!media || media.dataset.mediaType !== 'image') return;
 
            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();
 
            const index = this.getMediaIndex(media);
 
            if (this.lightbox) {
              this.lightbox.loadAndOpen(index);
            }
          },
          true
        );
      }
 
      bindDimensionImageZoom() {
        document.addEventListener(
          'click',
          (event) => {
            const link = event.target.closest('a[href]');
 
            if (!link) return;
 
            const href = link.getAttribute('href') || '';
 
            if (!/\.(jpg|jpeg|png|webp|gif|avif)(\?.*)?$/i.test(href)) return;
 
            const container = link.closest(
              'details, .accordion, .accordion-item, .product__accordion, .collapsible-content, .product__block'
            );
 
            if (!container) return;
 
            const containerText = String(container.innerText || '').toLowerCase();
 
            if (!containerText.includes('dimension')) return;
 
            event.preventDefault();
            event.stopPropagation();
            event.stopImmediatePropagation();
 
            const links = [...container.querySelectorAll('a[href]')].filter((item) => {
              return /\.(jpg|jpeg|png|webp|gif|avif)(\?.*)?$/i.test(item.getAttribute('href') || '');
            });
 
            const uniqueLinks = links.filter((item, index, arr) => {
              return arr.findIndex((inner) => inner.href === item.href) === index;
            });
 
            const dataSource = uniqueLinks.map((item) => {
              const img = item.querySelector('img');
 
              return {
                src: item.href,
                width: Number(img?.naturalWidth) || 2000,
                height: Number(img?.naturalHeight) || 2000,
                mediaType: 'image',
              };
            });
 
            const clickedIndex = Math.max(
              uniqueLinks.findIndex((item) => item.href === link.href),
              0
            );
 
            const dimensionLightbox = this.createLightbox(dataSource);
            dimensionLightbox.loadAndOpen(clickedIndex);
          },
          true
        );
      }
 
      handleSliderAfterInit() {
        this.sliderInstance.slider.on('afterInit', (swiper) => {
          this.forceSingleSlideLayout();
 
          const { slides, activeIndex } = swiper;
 
          if (slides[activeIndex]) {
            const isModelMediaType = slides[activeIndex].dataset.mediaType === 'model';
            this.toggleSliderDraggableState(!isModelMediaType);
          }
 
          swiper.update();
        });
      }
 
      handleSlideChange() {
        this.sliderInstance.slider.on('realIndexChange', (swiper) => {
          this.forceSingleSlideLayout();
 
          const { slides, activeIndex, realIndex, thumbs } = swiper;
 
          if (thumbs && thumbs.swiper) {
            thumbs.swiper.slideTo(realIndex, 0, false);
          }
 
          if (slides[activeIndex]) {
            this.playActiveMedia(slides[activeIndex]);
 
            const isModelMediaType = slides[activeIndex].dataset.mediaType === 'model';
            this.toggleSliderDraggableState(!isModelMediaType);
          }
        });
 
        this.sliderInstance.slider.on('slideChangeTransitionEnd', (swiper) => {
          this.forceSingleSlideLayout();
          swiper.update();
        });
      }
 
      toggleSliderDraggableState(isDraggable) {
        if (this.sliderInstance.slider.allowTouchMove !== isDraggable) {
          this.sliderInstance.slider.allowTouchMove = isDraggable;
        }
      }
 
      playActiveMedia(selected) {
        const deferredMedia = selected.querySelector('product-model');
 
        if (deferredMedia) {
          deferredMedia.loadContent(false);
        }
      }
 
      setActiveMedia(variant) {
        if (!variant || !variant.hasOwnProperty('featured_media') || !variant.featured_media) return;
 
        if (this.sliderInstance && this.sliderInstance.slider) {
          const allMedia = this.getCleanMediaItems();
 
          const targetIndex = allMedia.findIndex((media) => {
            return media.dataset.mediaId == variant.featured_media.id;
          });
 
          const safeIndex = targetIndex >= 0 ? targetIndex : 0;
 
          this.jumpToMediaIndex(safeIndex);
 
          setTimeout(() => {
            this.jumpToMediaIndex(safeIndex);
          }, 150);
 
          setTimeout(() => {
            this.jumpToMediaIndex(safeIndex);
          }, 400);
        } else {
          this.sortMediaItems(variant);
        }
      }
 
      sortMediaItems(variant) {
        let newMedias = this.elements.mediaItems;
 
        newMedias.sort(function (a, b) {
          return Number(a.dataset.mediaIndex) - Number(b.dataset.mediaIndex);
        });
 
        newMedias.some((media, index) => {
          if (media.dataset.mediaId == variant.featured_media.id) {
            const [element] = newMedias.splice(index, 1);
            newMedias.unshift(element);
            return true;
          }
 
          return false;
        });
 
        this.elements.mediaList.innerHTML = '';
 
        newMedias.forEach((media) => {
          this.elements.mediaList.appendChild(media);
        });
 
        if (!FoxTheme.config.mqlMobile) {
          const selectedMedia = this.querySelector(`[data-media-id="${variant.featured_media.id}"]`);
 
          if (selectedMedia) {
            window.scrollTo({
              top: selectedMedia.offsetTop,
              behavior: 'smooth',
            });
          }
        }
      }
    }
  );
}